class LqdFancyImageHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initCustomAnimation();
    this.initHover3d();
    this.initReveal();
    this.initInView();

  }

  getDefaultSettings() {
    return {
      isotopeData: null,
      selectors: {
        customAnimationElement: '[data-custom-animations]',
        hover3dElement: '[data-hover3d]',
        revealElement: '[data-reveal]',
        inViewElement: '[data-inview]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
      $hover3dElement: this.$element.find(selectors.hover3dElement),
      $revealElement: this.$element.find(selectors.revealElement),
      $inViewElement: this.$element.find(selectors.inViewElement),
    }
  }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  initHover3d() {

    this.elements.$hover3dElement.liquidHover3d();

  }

  initReveal() {

    this.elements.$revealElement.liquidReveal();

  }

  initInView() {

    this.elements.$inViewElement.liquidInView();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleCustomAnimationDestroy();
    this.handleHover3dDestroy();

  }

  handleCustomAnimationDestroy() {

    if ( ! this.elements.$customAnimationElement.length ) return;

    const customAnimationData = this.elements.$customAnimationElement.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }

  handleHover3dDestroy() {

    if ( ! this.elements.$hover3dElement.length ) return;

    const hover3dData = this.elements.$hover3dElement.data('plugin_liquidHover3d');

    if ( hover3dData ) {
      hover3dData.destroy();
    }

  }

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdFancyImageHandler, { $element } );
};